"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4021],{

/***/ 57123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30585);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var formik_material_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24065);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-bottom: 0.5em;\n  display: flex;\n  justify-content: ",
        ";\n  font-size: 12px;\n  .Mui-focusVisible {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n  .MuiTypography-root {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiFormControlLabel-label {\n    align-self: center;\n    font-size: 12px;\n    line-height: 1.2;\n    color: ",
        ";\n  }\n  .MuiFormControlLabel-label-273 {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -0.5em;\n  right: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormikCheckboxField__StyledContainer",
    componentId: "sc-38339090-0"
})(_templateObject(), function(p) {
    return p.$isCentered ? "center" : "flex-start";
});
var StyledCheckboxWithLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(formik_material_ui__WEBPACK_IMPORTED_MODULE_3__/* .CheckboxWithLabel */ .$B).withConfig({
    displayName: "FormikCheckboxField__StyledCheckboxWithLabel",
    componentId: "sc-38339090-1"
})(_templateObject1(), function(p) {
    return p.theme.palette.text.secondary;
});
var StyledError = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "FormikCheckboxField__StyledError",
    componentId: "sc-38339090-2"
})(_templateObject2());
var FormikCheckboxField = function(param) {
    var name = param.name, label = param.label, labelStyles = param.labelStyles, required = param.required, inputRef = param.inputRef, isCentered = param.isCentered, className = param.className, classes = param.classes;
    var ref = (0,formik__WEBPACK_IMPORTED_MODULE_2__.useFormikContext)(), errors = ref.errors, touched = ref.touched;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContainer, {
        $isCentered: isCentered,
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__.Field, {
                component: StyledCheckboxWithLabel,
                type: "checkbox",
                color: "primary",
                required: required,
                name: name,
                Label: {
                    label: label,
                    style: {
                        marginLeft: 0
                    }
                },
                inputRef: inputRef,
                inputProps: {
                    "aria-describedby": "".concat(name, "-helper-text")
                },
                classes: classes
            }),
            errors[name] && touched[name] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledError, {
                id: "".concat(name, "-helper-text"),
                error: true,
                children: errors[name]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikCheckboxField);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 43188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ postCallboxLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);





var CALLBOX_URL = "https://scripts.callbox.co.il/mazda/forms2cb.php";
var postCallboxLead = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(formType, leadRequest) {
        var ref, ref1, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post(CALLBOX_URL, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, leadRequest), {
                            sid: (window === null || window === void 0 ? void 0 : (ref = window.__ctm) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.sid) || "",
                            formType: formType
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function postCallboxLead(formType, leadRequest) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 44039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vs": function() { return /* binding */ isModelHasMeetingIframe; },
/* harmony export */   "yz": function() { return /* binding */ isModelHasTestDriveIframe; }
/* harmony export */ });
/* unused harmony exports getTestDriveIframeLink, getMeetingIframeLink */
var getTestDriveIframeLink = function(modelId) {
    switch(modelId){
        case 21:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA 2&langbar=0";
        case 2:
        case 3:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA 3&langbar=0";
        case 17:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA CX 3&langbar=0";
        case 6:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA CX 30&langbar=0";
        case 12:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA CX5&langbar=0";
        case 13:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&RGP=MAZDA 6&langbar=0";
        default:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU?sitesGroupID=MAZ&langbar=0";
    }
};
var getMeetingIframeLink = function(modelId) {
    switch(modelId){
        case 21:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA 2&langbar=0";
        case 2:
        case 3:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA 3&langbar=0";
        case 17:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA CX 3&langbar=0";
        case 6:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA CX 30&langbar=0";
        case 12:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA CX5&langbar=0";
        case 13:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&RG=MAZDA 6&langbar=0";
        default:
            return "https://yoman.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0?sitesGroupID=MAZ&langbar=0";
    }
};
var isModelHasTestDriveIframe = function(modelId) {
    return [
        21,
        2,
        3,
        17,
        6,
        12,
        13
    ].includes(modelId);
};
var isModelHasMeetingIframe = function(modelId) {
    return [
        21,
        2,
        3,
        17,
        6,
        12,
        13
    ].includes(modelId);
};


/***/ }),

/***/ 33041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45053);
/* harmony import */ var reusable_ButtonBaseBlank__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59041);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6089);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  /* if not last child add border bottom */\n  padding: 16px;\n  cursor: pointer;\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledButtonBase = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(reusable_ButtonBaseBlank__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "PurchaseToolsRow__StyledButtonBase",
    componentId: "sc-3b395d3f-0"
})(_templateObject(), function(p) {
    return p.theme.colors.borderGrey;
});
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .TypographyRtl */ .UE).attrs({
    variant: "body2"
}).withConfig({
    displayName: "PurchaseToolsRow__StyledText",
    componentId: "sc-3b395d3f-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) === components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_2__/* .STEPS_EN.summary */ .Ws.summary && "\n  font-size: 16px;\n  font-family: ".concat(components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_2__/* .Font.OENaPro */ .Zx.OENaPro, ";\n  ");
});
var PurchaseToolsRow = function(_param) {
    var iconName = _param.iconName, text = _param.text, page = _param.page, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "iconName",
        "text",
        "page"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonBase, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .StyledRow */ .N0, {
                $gap: "10px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .StyledSvgIcon */ .vV, {
                        src: "/icons/".concat(iconName, ".svg"),
                        alt: text,
                        w: 24,
                        h: 24,
                        role: "presentation",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                        $page: page,
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .StyledSvgIcon */ .vV, {
                src: "/icons/grayArrow.svg",
                alt: text,
                w: 18,
                h: 18
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PurchaseToolsRow);


/***/ }),

/***/ 12821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ FormStatus; },
  "Z": function() { return /* binding */ testDrive_TestDrivePopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/FormikCheckboxField.tsx
var FormikCheckboxField = __webpack_require__(57123);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./common/bit/utils/utmParams.ts
var utmParams = __webpack_require__(21172);
// EXTERNAL MODULE: ./common/postCallboxLead.ts
var postCallboxLead = __webpack_require__(43188);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/formsComp/FormErrorState.tsx + 1 modules
var FormErrorState = __webpack_require__(99763);
// EXTERNAL MODULE: ./reusable/formsComp/FormInput.tsx
var FormInput = __webpack_require__(77498);
// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
// EXTERNAL MODULE: ./reusable/formsComp/FormSuccessState.tsx
var FormSuccessState = __webpack_require__(27047);
// EXTERNAL MODULE: ./reusable/popups/ClassicPopUp.tsx
var ClassicPopUp = __webpack_require__(66395);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/carModelPage/popups/testDrive/SchemaTestDrive.ts


var schemaTestDrive = es/* object */.Ry({
    firstName: FormikSchema/* schemaCommon.firstName */.Cr.firstName,
    lastName: FormikSchema/* schemaCommon.lastName */.Cr.lastName,
    email: FormikSchema/* schemaCommon.email */.Cr.email,
    phoneNumber: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
    showRoom: es/* string */.Z_().required("שדה חובה"),
    carModel: es/* string */.Z_()
}).defined();
var initialFormStatesTestDrive = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    showRoom: "",
    carModel: ""
};
/* harmony default export */ var SchemaTestDrive = (schemaTestDrive);

;// CONCATENATED MODULE: ./components/carModelPage/popups/testDrive/SchemaTestDriveContact.ts


var schemaTestDriveContact = es/* object */.Ry({
    firstName: FormikSchema/* schemaCommon.firstName */.Cr.firstName,
    lastName: FormikSchema/* schemaCommon.lastName */.Cr.lastName,
    email: FormikSchema/* schemaCommon.email */.Cr.email,
    phoneNumber: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
    showRoom: es/* string */.Z_().required("שדה חובה"),
    carModel: es/* string */.Z_().required("שדה חובה")
}).defined();
var SchemaTestDriveContact_initialFormStatesTestDrive = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    showRoom: "",
    carModel: ""
};
/* harmony default export */ var SchemaTestDriveContact = (schemaTestDriveContact);

;// CONCATENATED MODULE: ./components/carModelPage/popups/testDrive/TestDrivePopup.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiDialog-paper {\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  ",
        " {\n    .MuiFormControl-root {\n      margin-top: 10px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0px;\n  height: 45px;\n  background: ",
        ";\n  color: white;\n  :hover {\n    background: ",
        ";\n    outline: none;\n  }\n  &:focus-visible {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  gap: 2px;\n\n  ",
        " {\n    flex-direction: row;\n    column-gap: 16px;\n    margin-bottom: 30px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 320px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 296px;\n\n  .MuiSelect-root {\n    &:focus-visible {\n      border: 0;\n      outline: 0;\n    }\n  }\n\n  ",
        "\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  legend {\n    width: 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  margin-top: 30px;\n  span {\n    user-select: none;\n    font-size: 16px;\n  }\n\n  span[class*="PrivateSwitchBase-root"] {\n    padding: 0 9px 9px 9px;\n    &:focus {\n      border: 2px dashed white;\n      outline: 3px dashed #0e3487;\n      outline-offset: 2px;\n    }\n  }\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



















var StyledClassicPopUp = (0,styled_components_browser_esm/* default */.ZP)(ClassicPopUp/* default */.Z).withConfig({
    displayName: "TestDrivePopup__StyledClassicPopUp",
    componentId: "sc-902531ea-0"
})(_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$isIframe) && "\n    width: 960px;\n    max-width: 100% !important;\n    ".concat(p.theme.breakpoints.down("sm"), " {\n        &.mobile-margin{\n          width: calc(100% - 30px);\n        }\n      }\n    ");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$isModelPage) && "\n  .MuiPaper-root {\n    margin: 30px 0;\n  }";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TestDrivePopup__StyledWrapper",
    componentId: "sc-902531ea-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TestDrivePopup__StyledFormDiv",
    componentId: "sc-902531ea-2"
})(_templateObject2());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "TestDrivePopup__StyledButton",
    componentId: "sc-902531ea-3"
})(_templateObject3(), function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.black;
}, function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.steel;
});
var StyledRowCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TestDrivePopup__StyledRowCol",
    componentId: "sc-902531ea-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$type) === "mail" && "margin-bottom: 20px !important;";
});
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TestDrivePopup__StyledWrap",
    componentId: "sc-902531ea-5"
})(_templateObject5());
var StyledRequiredFields = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "TestDrivePopup__StyledRequiredFields",
    componentId: "sc-902531ea-6"
})(_templateObject6(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledFormSelect = (0,styled_components_browser_esm/* default */.ZP)(FormSelect/* default */.Z).withConfig({
    displayName: "TestDrivePopup__StyledFormSelect",
    componentId: "sc-902531ea-7"
})(_templateObject7(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$isShop) && "\n    width: 296px;\n\n    label {\n      position: relative;\n      top: ".concat((p === null || p === void 0 ? void 0 : p.$isModelPage) ? "16px" : "10px", ';\n      right: 10px;\n    }\n\n    label[class*="MuiInputLabel-shrink"] {\n      transform: translate(8px, -6px) scale(0.75);\n    }\n  ');
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
    displayName: "TestDrivePopup__StyledFormInput",
    componentId: "sc-902531ea-8"
})(_templateObject8());
var StyledFormikCheckboxField = (0,styled_components_browser_esm/* default */.ZP)(FormikCheckboxField/* default */.Z).withConfig({
    displayName: "TestDrivePopup__StyledFormikCheckboxField",
    componentId: "sc-902531ea-9"
})(_templateObject9());
var getFormName = function(formType) {
    if (formType === "meeting") return "Mazda_meeting_form";
    if (formType === "financing") return "Mazda_funding_form";
    if (formType === "test-drive") return "Mazda_test_drive_form";
    return "Mazda_meeting_form";
};
var FormStatus;
(function(FormStatus) {
    FormStatus["Normal"] = "normal";
    FormStatus["Success"] = "success";
    FormStatus["Error"] = "error";
})(FormStatus || (FormStatus = {}));
var TestDrivePopup = function(param) {
    var onClose = param.onClose, open = param.open, showRoomsList = param.showRoomsList, _modelsOptions = param.modelsOptions, modelsOptions = _modelsOptions === void 0 ? [] : _modelsOptions, contactForm = param.contactForm, dialogClass = param.dialogClass, buttonText = param.buttonText, formType = param.formType, title = param.title, modelId = param.modelId, userInfo = param.userInfo, analyticName = param.analyticName, isShop = param.isShop;
    var ref = (0,react.useState)(FormStatus.Normal), formStatus = ref[0], setFormStatus = ref[1];
    var showRoomsOptions = (0,FormSelect/* toFormSelectOptions */.L)(showRoomsList, "id", "name");
    var models = (0,FormSelect/* toFormSelectOptions */.L)(modelsOptions, "id", "name");
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref1 = (0,router.useRouter)(), query = ref1.query, pathname = ref1.pathname;
    var isModelPage = pathname.indexOf("/model") === 0;
    var initialValues = {
        firstName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName) || "",
        lastName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName) || "",
        mobilePhone: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobilePhone) || "",
        emailAddress: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailAddress) || "",
        showRoom: "",
        over18: false,
        terms: false,
        isMailing: false,
        carModel: "",
        phoneNumber: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobilePhone) || "",
        email: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailAddress) || "",
        approveMailing: false
    };
    (0,react.useEffect)(function() {
        if (open) {
            (0,analytics/* trackPopUpOpen */.W1)(analyticName ? analyticName : "test drive");
        }
        if (!open) {
            setFormStatus(FormStatus.Normal);
        }
    }, [
        open
    ]);
    var checkboxLabel = "אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה.\n  ";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClassicPopUp, {
        open: open,
        onClose: onClose,
        title: title,
        dialogClass: dialogClass,
        hasError: formStatus === FormStatus.Error,
        $isModelPage: isModelPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            children: [
                formStatus === FormStatus.Normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                    validationSchema: contactForm ? SchemaTestDriveContact : SchemaTestDrive,
                    initialValues: initialValues,
                    onSubmit: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                            var ref, ref1, ref2, ref3, utmValues, carModelId, request, data, _tmp, error;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        utmValues = (0,utmParams/* getUtmParamsAsKeyValueList */.U)();
                                        carModelId = modelId || parseInt(query.modelId) || parseInt(values.carModel) || 0;
                                        request = formType === "test-drive" ? {
                                            carModelId: carModelId,
                                            showRoomId: values.showRoom ? parseInt(values.showRoom) : 0,
                                            firstName: values.firstName,
                                            lastName: values.lastName,
                                            phone: values.phoneNumber,
                                            email: values.email,
                                            contactSource: isDesktop ? "Pc" : "Mobile",
                                            utmValues: utmValues,
                                            approveMailingList: values.isMailing,
                                            sid: (window === null || window === void 0 ? void 0 : (ref = window.__ctm) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.sid) || "",
                                            formName: getFormName(formType)
                                        } : {
                                            fullName: "".concat(values.firstName, " ").concat(values.lastName),
                                            phone: values.phoneNumber,
                                            description: "",
                                            mediaChannelId: "",
                                            branchId: Number(values.showRoom),
                                            modelId: carModelId !== null && carModelId !== void 0 ? carModelId : null,
                                            platform: isDesktop ? "Pc" : "Mobile",
                                            isMailing: values === null || values === void 0 ? void 0 : values.isMailing,
                                            utmValues: utmValues,
                                            emailAddress: values === null || values === void 0 ? void 0 : values.email,
                                            sid: (window === null || window === void 0 ? void 0 : (ref2 = window.__ctm) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.config) === null || ref3 === void 0 ? void 0 : ref3.sid) || "",
                                            formName: getFormName(formType)
                                        };
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(formType === "test-drive")) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            (0,api/* postContactDriveTestReservation */.jT)(request)
                                        ];
                                    case 2:
                                        _tmp = _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            (0,api/* postContactEcommContact */._q)(request)
                                        ];
                                    case 4:
                                        _tmp = _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        data = _tmp.data;
                                        (0,postCallboxLead/* postCallboxLead */.b)(formType, request);
                                        if (data.body) {
                                            (0,analytics/* trackSuccessLead */.KZ)(analyticName ? analyticName : "test drive", "lead_success");
                                            (0,analytics/* trackPersonalDetails */.AB)(formType === "test-drive" ? "TestDrive" : "Meeting", values.email, values.phoneNumber, false);
                                            setFormStatus(FormStatus.Success);
                                        } else {
                                            setFormStatus(FormStatus.Error);
                                        }
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        error = _state.sent();
                                        console.log(error);
                                        setFormStatus(FormStatus.Error);
                                        return [
                                            3,
                                            7
                                        ];
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    render: function(formik) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormDiv, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequiredFields, {
                                    children: "* שדות חובה"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                            name: "firstName",
                                            label: "שם פרטי",
                                            required: true,
                                            autoComplete: "given-name",
                                            onFocusCapture: function() {
                                                return (0,analytics/* trackPopUpClicks */.dC)(analyticName ? analyticName : "test drive", "firstName");
                                            },
                                            marginTop: isDesktop ? 10 : 0
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                            name: "lastName",
                                            label: "שם משפחה",
                                            required: true,
                                            autoComplete: "family-name",
                                            onFocusCapture: function() {
                                                return (0,analytics/* trackPopUpClicks */.dC)(analyticName ? analyticName : "test drive", "lastName");
                                            },
                                            marginTop: isDesktop ? 10 : 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                    $type: "mail",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                            marginTop: 0,
                                            name: "email",
                                            label: "כתובת מייל",
                                            required: true,
                                            type: "email",
                                            autoComplete: "email",
                                            onFocusCapture: function() {
                                                return (0,analytics/* trackPopUpClicks */.dC)(analyticName ? analyticName : "test drive", "email");
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                            marginTop: 0,
                                            name: "phoneNumber",
                                            label: "טלפון נייד",
                                            type: "tel",
                                            required: true,
                                            autoComplete: "tel-national",
                                            onFocusCapture: function() {
                                                return (0,analytics/* trackPopUpClicks */.dC)(analyticName ? analyticName : "test drive", "phoneNumber");
                                            }
                                        })
                                    ]
                                }),
                                contactForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                    name: "carModel",
                                    required: true,
                                    label: "בחירת דגם רכב",
                                    values: models,
                                    map: function(item) {
                                        return {
                                            id: item.id,
                                            name: item.name
                                        };
                                    },
                                    onClick: function() {
                                        return (0,analytics/* trackPopUpClicks */.dC)(analyticName ? analyticName : "test drive", "carModel");
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormSelect, {
                                    $isShop: isShop,
                                    $isModelPage: isModelPage,
                                    marginTop: 0,
                                    name: "showRoom",
                                    required: true,
                                    label: "בחירת אולם תצוגה",
                                    values: showRoomsOptions,
                                    map: function(item) {
                                        return {
                                            id: item.id,
                                            name: item.name
                                        };
                                    },
                                    onClick: function() {
                                        return (0,analytics/* trackPopUpClicks */.dC)(analyticName ? analyticName : "test drive", "showRoom");
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormikCheckboxField, {
                                    name: "isMailing",
                                    label: checkboxLabel,
                                    required: true,
                                    classes: {
                                        root: "orderCheckbox"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrap, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        disabled: formik.isSubmitting,
                                        fullWidth: true,
                                        variant: "text",
                                        type: "submit",
                                        children: buttonText || "חִזרו אליי לתיאום הנסיעה"
                                    })
                                })
                            ]
                        });
                    }
                }),
                formStatus === FormStatus.Error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorState/* default */.ZP, {}),
                formStatus === FormStatus.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessState/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var testDrive_TestDrivePopup = (TestDrivePopup);


/***/ }),

/***/ 40739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87018);
/* harmony import */ var components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45053);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var reusable_colors_ColorCircle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10682);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57833);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50067);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22546);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22038);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6089);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  width: 100%;\n  max-width: 700px;\n  margin: 0px auto;\n  overflow: ",
        ";\n\n  ",
        " {\n    margin-top: ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &:first-child {\n          transform: scale(0.65) translate(10px, 10px) !important;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        transform: scale(0.65) translate(10px, 0px) !important;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        transform: scale(0.65) translate(-10px, 0px) !important;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100px;\n  width: 100%;\n  max-width: 560px;\n\n  & .swiper-wrapper {\n    transition-timing-function: cubic-bezier(0.47, 0.5, 0.57, 1.19);\n  }\n  .swiper-slide,\n  .swiper-slide-duplicate {\n    opacity: 0;\n    transition: 0.3s ease all;\n    transform: scale(0.65) translate(0, 10px) !important;\n    transform-origin: top;\n  }\n  .swiper-slide-visible,\n  .swiper-slide-duplicate-visible {\n    opacity: 1;\n    ",
        "\n  }\n  .swiper-slide-active,\n  .swiper-slide-duplicate-active {\n    /* opacity: 1; */\n    transform: scale(1) !important;\n  }\n  .swiper-slide-next,\n  .swiper-slide-duplicate-next {\n    transform: scale(0.65) translate(-10px, 10px) !important;\n    ",
        "\n  }\n  .swiper-slide-prev,\n  .swiper-slide-duplicate-prev {\n    transform: scale(0.65) translate(10px, 10px) !important;\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: auto;\n  box-sizing: border-box;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  opacity: 0;\n  opacity: ",
        ";\n  transition: 0.3s ease all;\n  pointer-events: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n      top: 0;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  color: ",
        ";\n  text-align: center;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  left: 0;\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: absolute;\n      bottom: 100%;\n      left: 0;\n      width: 100%;\n      text-shadow: 0px 4px 10px rgb(0 0 0 / 10%);\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n  height: 45px;\n  ",
        "\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}










var StyledWrap = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorsCarousel__StyledWrap",
    componentId: "sc-fcd4d31e-0"
})(_templateObject(), function(p) {
    return p.$pathname === components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__/* .STEPS_EN.color */ .Ws.color || p.$pathname === "product" ? "visible !important" : "hidden";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    if (p.$pathname == components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__/* .STEPS_EN.upholstery */ .Ws.upholstery) return "4px";
    if (p.$pathname == components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__/* .STEPS_EN.color */ .Ws.color) return "0px";
    return "4px";
}, function(p) {
    if (p.$pathname === components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__/* .STEPS_EN.color */ .Ws.color) {
        return "\n      position: relative;\n      top: -40px;\n    ";
    }
});
var StyledSwiperWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorsCarousel__StyledSwiperWrapper",
    componentId: "sc-fcd4d31e-1"
})(_templateObject1());
var StyledSwiperJs = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .tq).attrs({}).withConfig({
    displayName: "ColorsCarousel__StyledSwiperJs",
    componentId: "sc-fcd4d31e-2"
})(_templateObject5(), function(p) {
    return p.loop && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject2());
}, function(p) {
    return p.slidesPerView !== "auto" && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject3());
}, function(p) {
    return p.slidesPerView !== "auto" && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject4());
});
var StyledSwiperSlide = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o5).withConfig({
    displayName: "ColorsCarousel__StyledSwiperSlide",
    componentId: "sc-fcd4d31e-3"
})(_templateObject6());
var StyledCircle = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(reusable_colors_ColorCircle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "ColorsCarousel__StyledCircle",
    componentId: "sc-fcd4d31e-4"
})(_templateObject7(), function(p) {
    return p.$isVisible ? 1 : 0;
}, function(p) {
    return !p.$colorChange ? "auto" : "none";
});
var StyledNotInStock = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorsCarousel__StyledNotInStock",
    componentId: "sc-fcd4d31e-5"
})(_templateObject9(), function(p) {
    return p.$active ? "10px" : "16px";
}, function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.$active && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject8());
});
var StyledTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorsCarousel__StyledTextWrapper",
    componentId: "sc-fcd4d31e-6"
})(_templateObject11(), function(p) {
    return p.$position === "top" && (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject10());
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$pathname === components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__/* .STEPS_EN.upholstery */ .Ws.upholstery && "justify-content: flex-end;";
});
//
// THIS IS A SHARED COMPONENT BETWEEN CAR MODEL PAGE AND SHOP FEATURES WIZARD. PLACE CHANGES ACCORDINGLY.
// and make sure it is not breaking the other component.
//
var ColorsCarousel = function(param) {
    var colorsData = param.colorsData, selectedColorIndex = param.selectedColorIndex, handleColorChange = param.handleColorChange, _loop = param.loop, loop = _loop === void 0 ? true : _loop, _textPosition = param.textPosition, textPosition = _textPosition === void 0 ? "bottom" : _textPosition, colorChange = param.colorChange, _showExtraPrice = param.showExtraPrice, showExtraPrice = _showExtraPrice === void 0 ? false : _showExtraPrice, _pathname = param.pathname, pathname = _pathname === void 0 ? "product" : _pathname;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(selectedColorIndex || 0), selectedColorNumber = ref2[0], setSelectedColorNumber = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), mounted = ref3[0], setMounted = ref3[1];
    var VISUAL_SLIDES = 7;
    // loop Array, concat colorsData array as much times that is needed based on VISUAL_SLIDES const value. the array length needs to be at least double the VISUAL_SLIDES const value.
    var loopArray = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (!loop) return colorsData;
        var originalArray = colorsData;
        var duplicatedArray = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(originalArray);
        try {
            while(duplicatedArray.length < VISUAL_SLIDES * 2){
                duplicatedArray = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(duplicatedArray).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(originalArray));
            }
        } catch (error) {
            console.log(error);
        }
        return duplicatedArray;
    }, [
        colorsData,
        loop
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (window) setMounted(true);
    }, []);
    var getAdditionalPriceContent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var color = colorsData[selectedColorNumber];
        if ((color === null || color === void 0 ? void 0 : color.additionalPrice) && showExtraPrice) return "תוספת מחיר - ".concat(color === null || color === void 0 ? void 0 : color.additionalPrice);
        if ((color === null || color === void 0 ? void 0 : color.additionalPrice) || (color === null || color === void 0 ? void 0 : color.hasAdditionalPrice)) return "בתוספת מחיר";
    }, [
        colorsData,
        selectedColorNumber,
        showExtraPrice
    ]);
    if (!mounted) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrap, {
        $pathname: pathname,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSwiperWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSwiperJs, {
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Keyboard */ .N1,
                        swiper__WEBPACK_IMPORTED_MODULE_6__/* .Parallax */ .VS
                    ],
                    loop: loop,
                    parallax: true,
                    slidesPerView: pathname === components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_3__/* .STEPS_EN.upholstery */ .Ws.upholstery ? 3 : "auto",
                    allowTouchMove: true,
                    grabCursor: true,
                    slideToClickedSlide: true,
                    centeredSlides: true,
                    resizeObserver: true,
                    initialSlide: selectedColorIndex || 0,
                    keyboard: {
                        enabled: true
                    },
                    onSlideChange: function(swiper) {
                        // get colorIndex based on that the original array was LOOP_REPEAT the length
                        var colorIndex = swiper.realIndex % colorsData.length;
                        handleColorChange && handleColorChange(colorIndex);
                        setSelectedColorNumber(colorIndex);
                    },
                    children: loopArray.map(function(color, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSwiperSlide, {
                            id: "swiperr-".concat(index),
                            children: function(param) {
                                var isVisible = param.isVisible, isActive = param.isActive;
                                var ref;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCircle, {
                                            $isVisible: isVisible,
                                            hex: (color === null || color === void 0 ? void 0 : color.hex) || "",
                                            imageUrl: color === null || color === void 0 ? void 0 : (ref = color.colorImage) === null || ref === void 0 ? void 0 : ref.imageUrl,
                                            height: 80,
                                            $colorChange: colorChange,
                                            additionalPrice: color === null || color === void 0 ? void 0 : color.hasAdditionalPrice,
                                            onClick: function() {
                                                return (0,common_analytics__WEBPACK_IMPORTED_MODULE_2__/* .trackColorSliderModelPageClicks */ .ZW)();
                                            }
                                        }),
                                        !color.inStock && !isActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNotInStock, {
                                            $active: false,
                                            children: "לא במלאי"
                                        })
                                    ]
                                });
                            }
                        }, "swiperr-".concat(index));
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTextWrapper, {
                $position: textPosition,
                $pathname: pathname,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_9__/* .TypographyCenter */ .kc, {
                        $fontSize: "16px",
                        variant: "body2",
                        $color: textPosition === "top" ? theme_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].white */ .Z.white : theme_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].black */ .Z.black,
                        children: (ref = colorsData[selectedColorNumber]) === null || ref === void 0 ? void 0 : ref.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_9__/* .TypographyCenter */ .kc, {
                        variant: "caption",
                        $color: textPosition === "top" ? theme_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].white */ .Z.white : theme_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].disable */ .Z.disable,
                        children: getAdditionalPriceContent()
                    }),
                    !((ref1 = colorsData[selectedColorNumber]) === null || ref1 === void 0 ? void 0 : ref1.inStock) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNotInStock, {
                        $active: true,
                        children: "לא במלאי"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorsCarousel);


/***/ }),

/***/ 71231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);
/* harmony import */ var _pollutionColors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81623);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-top: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 30px;\n  width: 95%;\n  table {\n    width: 100%;\n  }\n  ",
        " {\n    width: 100%;\n    margin-top: 20px;\n  }\n  th,\n  td {\n    border: 1px solid ",
        ";\n    padding: 5px;\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-spacing: 0px;\n  text-align: center;\n  color: ",
        ";\n  thead {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  font-size: 11px;\n  font-weight: 400;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledCaption = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "PollutionTable__StyledCaption",
    componentId: "sc-b5cb80e9-0"
})(_templateObject());
var StyledCellDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PollutionTable__StyledCellDiv",
    componentId: "sc-b5cb80e9-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "PollutionTable__StyledTable",
    componentId: "sc-b5cb80e9-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "PollutionTable__StyledTh",
    componentId: "sc-b5cb80e9-3"
})(_templateObject3(), function(p) {
    return p.$minWidth && "min-width: ".concat(p.$minWidth, "px");
});
var PollutionTable = function(param) {
    var data = param.data;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCellDiv, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTable, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                    colSpan: 1,
                                    scope: "colgroup",
                                    children: "דגם"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                    colSpan: 2,
                                    scope: "colgroup",
                                    $minWidth: isDesktop && 220,
                                    children: "צריכת דלק בליטרים ל100 ק״מ*"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                    colSpan: 1,
                                    scope: "colgroup",
                                    children: "דרגת זיהום"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                        children: data === null || data === void 0 ? void 0 : data.pollutionTable.map(function(item, i) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        children: item === null || item === void 0 ? void 0 : item.finishingLevelFullName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        children: item.fuelConsuption
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        children: item.consuptionType
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        style: {
                                            background: _pollutionColors__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z[item.pullotionLevel - 1],
                                            color: "#FFFFFF"
                                        },
                                        children: item.pullotionLevel
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCaption, {
                children: data.pollutionComment
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PollutionTable);


/***/ }),

/***/ 70554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57833);
/* harmony import */ var _safetyColors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34763);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 30px;\n  width: 95%;\n  ",
        " {\n    width: 100%;\n  }\n  th,\n  td {\n    border: 1px solid ",
        ";\n    padding: 5px;\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-spacing: 0px;\n  text-align: center;\n  width: 100%;\n  color: ",
        ";\n  thead {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 11px;\n  font-weight: 400;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledCellDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SafetyTable__StyledCellDiv",
    componentId: "sc-75f68bbc-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "SafetyTable__StyledTable",
    componentId: "sc-75f68bbc-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "SafetyTable__StyledTh",
    componentId: "sc-75f68bbc-2"
})(_templateObject2());
var SafetyTable = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCellDiv, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                colSpan: 1,
                                scope: "colgroup",
                                children: "קוד דגם"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                colSpan: 1,
                                scope: "colgroup",
                                children: "תיאור דגם"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                colSpan: 1,
                                scope: "colgroup",
                                children: "רמת האבזור הבטיחותי"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                    children: data === null || data === void 0 ? void 0 : data.safetyTable.map(function(item, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    children: item.finishingLevelCode
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    children: item.finishingLevelFullName
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    style: {
                                        background: _safetyColors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[item.safetyLevel],
                                        color: "#FFFFFF"
                                    },
                                    children: item.safetyLevel
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafetyTable);


/***/ }),

/***/ 81623:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var pollutionColors = [
    "#29503e",
    "#006543",
    "#007a49",
    "#00904b",
    "#00a652",
    "#33992b",
    "#50b849",
    "#fdf100",
    "#ffcb05",
    "#f9a61a",
    "#f48221",
    "#f55820",
    "#d93b20",
    "#ca252c",
    "#ca252c", 
];
/* harmony default export */ __webpack_exports__["Z"] = (pollutionColors);


/***/ }),

/***/ 34763:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var safetyColors = [
    "#a72c31",
    "#f15a23",
    "#ffcb05",
    "#26b78c",
    "#31899f",
    "#238bca",
    "#1b6fb7",
    "#4170b6",
    "#435daa", 
];
/* harmony default export */ __webpack_exports__["Z"] = (safetyColors);


/***/ }),

/***/ 10682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  position: relative;\n  border-radius: 400px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  border: 2px solid #ffffff;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  width: ",
        ";\n  height: ",
        ";\n  padding: 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var circleStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), function(p) {
    return "".concat(p.$height, "px");
}, function(p) {
    return "".concat(p.$height, "px");
});
var StyledCircleButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "ColorCircle__StyledCircleButton",
    componentId: "sc-7653b1a1-0"
})(_templateObject1(), circleStyle);
var StyledCircleDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircle__StyledCircleDiv",
    componentId: "sc-7653b1a1-1"
})(_templateObject2(), circleStyle);
var ImageWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircle__ImageWrap",
    componentId: "sc-7653b1a1-2"
})(_templateObject3());
var ColorCircle = function(param) {
    var _height = param.height, height = _height === void 0 ? 85 : _height, className = param.className, imageUrl = param.imageUrl, additionalPrice = param.additionalPrice, disableButton = param.disableButton, onClick = param.onClick;
    // set StyledCircle to be a button or a div react component
    var StyledCircle = disableButton ? StyledCircleDiv : StyledCircleButton;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCircle, {
        className: className,
        $height: height,
        onClick: onClick,
        children: imageUrl && imageUrl !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrap, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: imageUrl,
                alt: additionalPrice ? "בתוספת מחיר" : "color Backround",
                width: height,
                height: height,
                objectFit: "cover"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorCircle);


/***/ }),

/***/ 99763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ formsComp_FormErrorState; }
});

// UNUSED EXPORTS: StyledSubTitle, StyledSvgContainer, StyledTitle

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./reusable/formsComp/FormWarningSvgIcon.tsx

var FormSvgIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "76",
        height: "76",
        viewBox: "0 0 76 76",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.00003 67.5829C1.00321 66.2685 1.30426 64.9844 1.86593 63.859L32.6659 4.50703C32.6662 4.5064 32.6665 4.50578 32.6668 4.50515C33.2415 3.4123 34.0413 2.526 34.9763 1.9184C35.9102 1.31147 36.9511 1 38 1C39.0489 1 40.0898 1.31147 41.0237 1.9184C41.9585 2.52588 42.7582 3.41196 43.3328 4.50453C43.3333 4.50536 43.3337 4.5062 43.3341 4.50703L74.1309 63.8526C74.132 63.8548 74.1331 63.8571 74.1342 63.8593C74.6958 64.9846 74.9968 66.2686 75 67.5829C75.0032 68.8997 74.7072 70.1884 74.1488 71.3192C73.5906 72.4498 72.7943 73.3741 71.853 74.0134C70.9152 74.6504 69.8629 74.9852 68.7995 75H7.20053C6.13714 74.9852 5.08483 74.6504 4.147 74.0134C3.20572 73.3741 2.40944 72.4498 1.85117 71.3192C1.29278 70.1884 0.996831 68.8997 1.00003 67.5829Z",
                stroke: "black",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.4492 26.1016L38.4492 53.1016",
                stroke: "black",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.4492 59.2031H38.4856",
                stroke: "black",
                "stroke-width": "6",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./reusable/formsComp/FormErrorState.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 27px;\n  letter-spacing: 0em;\n  max-width: 325px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormErrorState__StyledWrapper",
    componentId: "sc-215887c-0"
})(_templateObject());
var StyledSvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FormErrorState__StyledSvgContainer",
    componentId: "sc-215887c-1"
})(_templateObject1());
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "FormErrorState__StyledTitle",
    componentId: "sc-215887c-2"
})(_templateObject2());
var StyledSubTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "FormErrorState__StyledSubTitle",
    componentId: "sc-215887c-3"
})(_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var FormErrorState = function(param) {
    var _title = param.title, title = _title === void 0 ? "משהו השתבש" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "נראה שמשהו השתבש ולא הצלחנו לרשום אותך. אנחנו נשוב אלייך מאוחר יותר." : _subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvgContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSvgIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                variant: "h2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubTitle, {
                variant: "body1",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ var formsComp_FormErrorState = (FormErrorState);


/***/ }),

/***/ 83225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formsComp_FormSelect; },
  "L": function() { return /* binding */ toFormSelectOptions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikSelect.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .MuiSelect-root {\n      &:focus-visible {\n        border: 2px dashed white;\n        outline: 3px dashed #0e3487;\n        outline-offset: 2px;\n      }\n    }\n\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-contained {\n      margin-right: 0;\n    }\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    /* text alignment: */\n    .MuiSelect-outlined.MuiSelect-outlined {\n      text-align: initial;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
        displayName: "FormikSelect__Field",
        componentId: "sc-fb0e1fb7-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hiddenLabel) && "label { display: none; }";
    })
};
function FormikSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, selectValues = _param.selectValues, map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "selectValues",
        "map",
        "placeholder",
        "hiddenLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        component: formik_material_ui_es6/* TextField */.nv,
        select: true,
        name: name,
        id: name,
        required: required,
        label: label,
        helperText: " ",
        $hiddenLabel: hiddenLabel,
        placeholder: placeholder
    }, props), {
        children: selectValues === null || selectValues === void 0 ? void 0 : selectValues.map(function(value, i) {
            var ref = map(value), name = ref.name, id = ref.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: id,
                children: name
            }, i);
        })
    }));
}
/* harmony default export */ var form_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./reusable/formsComp/FormSelect.tsx



function FormSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: start;\n    font-size: 12px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FormSelect_Styled = {
    FormControl: (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
        displayName: "FormSelect__FormControl",
        componentId: "sc-8af10bf7-0"
    })(FormSelect_templateObject()),
    FieldWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "FormSelect__FieldWrapper",
        componentId: "sc-8af10bf7-1"
    })(_templateObject1(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    InputLabel: (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
        displayName: "FormSelect__InputLabel",
        componentId: "sc-8af10bf7-2"
    })(_templateObject2(), function(p) {
        return p.theme.colors.darkGrey;
    }),
    BottomText: (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormSelect__BottomText",
        componentId: "sc-8af10bf7-3"
    })(_templateObject3(), function(p) {
        return p.theme.colors.marbleGrey;
    })
};
var toFormSelectOptions = function(list, idProp, nameProp) {
    return list.map(function(item) {
        return {
            id: item[idProp],
            name: item[nameProp]
        };
    });
};
function FormSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, values = _param.values, // bottomText,
    map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, marginTop = _param.marginTop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "values",
        "map",
        "placeholder",
        "hiddenLabel",
        "marginTop"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect_Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikSelect, (0,_object_spread/* default */.Z)({
                label: label,
                name: name,
                required: required,
                selectValues: values,
                hiddenLabel: hiddenLabel,
                map: map,
                placeholder: placeholder
            }, props))
        })
    });
}
/* harmony default export */ var formsComp_FormSelect = (FormSelect);


/***/ })

}]);